module.exports = __webpack_public_path__ + "static/media/Applelogo.d672cb33.png";